import { ActivityFilter } from 'generated/graphql'
import { ActivityTypeID } from 'constants/enums'

export type TFilterKey = keyof Pick<
  ActivityFilter,
  | 'categoryIDs'
  | 'orgTypeIDs'
  | 'jobTypes'
  | 'regionIDs'
  | 'benefitIDs'
  | 'interestIDs'
  | 'period'
  | 'reward'
  | 'targetIDs'
  | 'internTypeIds'
>

type TFilterLabel = TFilterKey | 'internTypes'

const BASE_FILTER_LABEL: {
  [key in TFilterLabel]: string
} = {
  benefitIDs: '활동혜택',
  categoryIDs: '활동분야',
  interestIDs: '관심분야',
  jobTypes: '채용형태',
  orgTypeIDs: '주최기관',
  period: '활동기간',
  regionIDs: '모임지역',
  targetIDs: '모임대상',
  reward: '시상규모',
  internTypeIds: '채용형태',
  internTypes: '채용형태',
}

export const FILTER_LABEL_BY_ACTIVITY_TYPE_ID: {
  [key in ActivityTypeID]: {
    [key in TFilterLabel]: string
  }
} = {
  [ActivityTypeID.ACTIVITY]: {
    ...BASE_FILTER_LABEL,
  },
  [ActivityTypeID.CLUB]: {
    ...BASE_FILTER_LABEL,
  },
  [ActivityTypeID.CONTEST]: {
    ...BASE_FILTER_LABEL,
    benefitIDs: '수상혜택',
    categoryIDs: '공모분야',
    targetIDs: '응모대상',
  },
  [ActivityTypeID.INTERN]: {
    ...BASE_FILTER_LABEL,
    categoryIDs: '모집직무',
    orgTypeIDs: '기업형태',
    internTypes: '채용형태',
    regionIDs: '근무지역',
  },
  [ActivityTypeID.RECRUIT]: {
    ...BASE_FILTER_LABEL,
    categoryIDs: '모집직무',
    orgTypeIDs: '기업형태',
    regionIDs: '근무지역',
  },
  [ActivityTypeID.EDUCATION]: {
    ...BASE_FILTER_LABEL,
  },
}
